import {
  SquaresFour, Pulse, Bank, AddressBook, ClipboardText, Receipt, BellRinging,
  Sparkle, UsersThree, UserGear, Database, Stack, IdentificationBadge,
} from "@phosphor-icons/react";

// Full navigation tree: top-level menu -> sub-menus (per the Sub-Menu Specification)
export const NAV_TREE = [
  {
    key: "dashboard", label: "Dashboard", icon: SquaresFour, to: "/app",
    children: [
      { to: "/app", end: true, label: "Overview" },
      { to: "/app/dashboard/banks", label: "Bank-wise Performance" },
      { to: "/app/dashboard/alerts", label: "Alerts & Notifications" },
      { to: "/app/activity", label: "Activity Log" },
    ],
  },
  {
    key: "client-data", label: "01 · Client Data", icon: AddressBook, to: "/app/clients",
    children: [
      { to: "/app/clients", end: true, label: "All Clients" },
      { to: "/app/clients/groups", label: "Client Groups" },
      { to: "/app/clients/import", label: "Import Clients" },
      { to: "/app/branches", label: "Bank Branches" },
      { to: "/app/branches/empanelment", label: "Empanelment Tracker" },
      { to: "/app/followups", label: "Follow-ups" },
      { to: "/app/outreach", label: "AI Outreach" },
    ],
  },
  {
    key: "valuation", label: "02 · Valuation Data", icon: ClipboardText, to: "/app/jobs",
    children: [
      { to: "/app/jobs", end: true, label: "All Jobs (Pipeline)" },
      { to: "/app/statutory-reports", label: "Statutory Reports" },
      { to: "/app/jobs/pipeline", label: "Pipeline Dashboard" },
      { to: "/app/jobs/calendar", label: "Site Visit Calendar" },
      { to: "/app/jobs/qc", label: "Report QC Queue" },
      { to: "/app/jobs/revisions", label: "Revision / Query Jobs" },
      { to: "/app/jobs/templates", label: "Report Templates" },
      { to: "/app/jobs/formats", label: "Bank Report Formats" },
      { to: "/app/jobs/property-types", label: "Property Types" },
    ],
  },
  {
    key: "gis", label: "03 · Historical Comparable (GIS)", icon: Stack, to: "/app/gis",
    children: [
      { to: "/app/gis", end: true, label: "Historical Data" },
    ],
  },
  {
    key: "team", label: "04 · Team Management", icon: UsersThree, to: "/app/team",
    children: [
      { to: "/app/team", end: true, label: "All Team Members" },
      { to: "/app/team/workload", label: "Workload" },
      { to: "/app/team/roles", label: "Roles & Permissions" },
      { to: "/app/team/valuers", label: "Valuer Profiles" },
      { to: "/app/team/drafts", label: "Draft Assignments" },
      { to: "/app/team/notifications", label: "Notification Preferences" },
      { to: "/app/team/availability", label: "Attendance / Availability" },
      { to: "/app/employees", label: "Salary & Attendance" },
      { to: "/app/employees?tab=visits", label: "Site Visits & Fuel" },
    ],
  },
  {
    key: "accounts", label: "05 · Accounts", icon: Receipt, to: "/app/invoices",
    children: [
      { to: "/app/invoices", end: true, label: "All Invoices" },
      { to: "/app/invoices/payments", label: "Payment Tracking" },
      { to: "/app/invoices/outstanding", label: "Outstanding / Overdue" },
      { to: "/app/invoices/bulk", label: "Bulk / Recurring" },
      { to: "/app/invoices/credit-notes", label: "Credit Notes" },
      { to: "/app/invoices/tax-settings", label: "GST & Tax Settings" },
      { to: "/app/invoices/reports", label: "Billing Reports" },
      { to: "/app/records", label: "Data Records" },
    ],
  },
  {
    key: "account", label: "My Account", icon: UserGear, to: "/app/account",
    children: [
      { to: "/app/account", end: true, label: "Profile Settings" },
      { to: "/app/account/firm", label: "Firm / Organization" },
      { to: "/app/account/notifications", label: "Notification Preferences" },
      { to: "/app/account/integrations", label: "Integrations" },
      { to: "/app/account/security", label: "Sign-in Devices" },
      { to: "/app/account/backup", label: "Data & Backup" },
    ],
  },
];

export const STAFF_NAV_TREE = [
  {
    key: "my-jobs", label: "My Jobs", icon: ClipboardText, to: "/app/my-jobs",
    children: [
      { to: "/app/my-jobs", end: true, label: "Assigned Jobs" },
      { to: "/app/jobs", label: "Prepare Valuation Report" },
      { to: "/app/jobs/calendar", label: "Site Visit Calendar" },
    ],
  },
  {
    key: "employees", label: "My Work & Salary", icon: IdentificationBadge, to: "/app/employees",
    children: [
      { to: "/app/employees", end: true, label: "Salary & Site Visits" },
    ],
  },
  {
    key: "account", label: "My Account", icon: UserGear, to: "/app/account",
    children: [
      { to: "/app/account", end: true, label: "Profile Settings" },
      { to: "/app/account/notifications", label: "Notification Preferences" },
    ],
  },
];

export const ACCOUNTANT_NAV_TREE = [
  {
    key: "invoices", label: "Invoices", icon: Receipt, to: "/app/invoices",
    children: [
      { to: "/app/invoices", end: true, label: "All Invoices" },
      { to: "/app/invoices/payments", label: "Payment Tracking" },
      { to: "/app/invoices/outstanding", label: "Outstanding / Overdue" },
      { to: "/app/invoices/bulk", label: "Bulk / Recurring" },
      { to: "/app/invoices/credit-notes", label: "Credit Notes" },
      { to: "/app/invoices/tax-settings", label: "GST & Tax Settings" },
      { to: "/app/invoices/reports", label: "Billing Reports" },
    ],
  },
  {
    key: "employees", label: "Employees", icon: IdentificationBadge, to: "/app/employees",
    children: [
      { to: "/app/employees", end: true, label: "Salary & Attendance" },
      { to: "/app/employees?tab=visits", label: "Site Visits & Fuel" },
    ],
  },
  {
    key: "account", label: "My Account", icon: UserGear, to: "/app/account",
    children: [
      { to: "/app/account", end: true, label: "Profile Settings" },
      { to: "/app/account/notifications", label: "Notification Preferences" },
    ],
  },
];
